export interface FeatureCard {
  id: string
  videoFileName: string
  posterFileName: string
  studioPath: string
}

export const FEATURE_CARDS: FeatureCard[] = [
  {
    id: 'image_editor',
    videoFileName: '01-image-editor.mp4',
    posterFileName: '01-image-editor.webp',
    studioPath: '/ai-image-editor',
  },
  {
    id: 'video_generator',
    videoFileName: '02-video-generator.mp4',
    posterFileName: '02-video-generator.webp',
    studioPath: '/ai-video-generator',
  },
  {
    id: 'nanobanana_2',
    videoFileName: '03-nano-banana.mp4',
    posterFileName: '03-nano-banana.webp',
    studioPath: '/flow',
  },
  {
    id: 'music_generator',
    videoFileName: '04-music-generator.mp4',
    posterFileName: '04-music-generator.webp',
    studioPath: '/ai-music-generator',
  },
  {
    id: 'logo_generator',
    videoFileName: '05-logo-generator.mp4',
    posterFileName: '05-logo-generator.webp',
    studioPath: '/logo-creator',
  },
  {
    id: 'seedream_2',
    videoFileName: '06-seedream.mp4',
    posterFileName: '06-seedream.webp',
    studioPath: '/ai-video-generator?model=seeddream',
  },
  {
    id: 'lyria_3',
    videoFileName: '07-lyria3.mp4',
    posterFileName: '07-lyria3.webp',
    studioPath: '/ai-music-generator',
  },
]
